import { HtmlText } from "./HtmlText";
import styles from "../Paragraph.module.css";

/**
 * Pojedynczy boks (layouty 17 = TWO_BOXES, 18 = THREE_BOXES).
 *
 * Współdzielony komponent dla [ParagraphTwoBoxes] i [ParagraphThreeBoxes]
 * - identyczna struktura DOM (image -> body -> title -> text -> cta) i ten sam
 * mechanizm color->background+auto-contrast.
 *
 * Color flow:
 * - Backend zapisuje hex bez `#` w `imp_paragraph.color` / `color_1` / `color_2`.
 * - Tu prepend `#` -> inline `style.background` (wygrywa z `.box` CSS rule).
 * - YIQ brightness -> auto text color (jasne tło -> ciemny tekst, ciemne -> bialy).
 *   Pomaga unikac nieczytelnych boksow gdy admin wybierze np. czarne tlo.
 */

function pickTextOnHex(hex: string): string | undefined {
  const h = hex.replace(/^#/, "").trim();
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return undefined;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 150 ? undefined : "#fff";
}

export function Box({
  name,
  text,
  image,
  color,
  buttonName,
  buttonUrl,
}: {
  name?: string | null;
  text: string;
  image?: string | null;
  color?: string | null;
  buttonName?: string | null;
  buttonUrl?: string | null;
}) {
  const hex = color?.trim() || "";
  const articleStyle: React.CSSProperties | undefined = hex
    ? { background: `#${hex.replace(/^#/, "")}`, borderColor: "transparent" }
    : undefined;
  const textOverride = hex ? pickTextOnHex(hex) : undefined;
  const bodyStyle: React.CSSProperties | undefined = textOverride
    ? { color: textOverride }
    : undefined;

  return (
    <article className={styles.box} style={articleStyle}>
      {image && (
        <img
          className={styles.boxImage}
          src={image}
          alt={name ?? ""}
          loading="lazy"
        />
      )}
      <div className={styles.boxBody} style={bodyStyle}>
        {name && <h3 className={styles.boxTitle}>{name}</h3>}
        <div className={styles.boxText}>
          <HtmlText html={text} />
        </div>
        {buttonName && buttonUrl && (
          <a href={buttonUrl} className={styles.boxCta}>
            {buttonName}
          </a>
        )}
      </div>
    </article>
  );
}
